import { InlineSVG, Text } from '../components';

import styles from './performance-promise.module.scss';

type Props = {
  component: Queries.Squidex_TextIconComponent;
};

export const PerformancePromise = ({ component }: Props) => (
  <div className={styles.wrapper}>
    <InlineSVG
      svg={component.icon?.[0]?.localFile?.svg?.content}
      className={styles.icon}
    />
    <Text size="fs-3" weight="fw-700" className={styles.text}>
      {component.text}
    </Text>
  </div>
);
